/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  GetFollowingQueryResponse,
  GetFollowing401,
} from "../types/GetFollowing.ts"
import { getFollowingQueryResponseSchema } from "../zod/getFollowingSchema.ts"

function getGetFollowingUrl() {
  const res = { method: "GET", url: `/following` as const }
  return res
}

/**
 * @summary Get encrypted profile data for all users you follow
 * {@link /following}
 */
export async function getFollowing(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetFollowingQueryResponse,
    ResponseErrorConfig<GetFollowing401>,
    unknown
  >({
    method: "GET",
    url: getGetFollowingUrl().url.toString(),
    ...requestConfig,
  })
  return getFollowingQueryResponseSchema.parse(res.data)
}
